import React, { useState } from 'react';
import { SectionWrapper } from './SectionWrapper';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { SharedCTA } from './SharedCTA';
const proFeatures = ['6 Tomos', '6 Bonos', 'Acceso inmediato', 'Garantía 7d'];
const eliteFeatures = ['Todo PRO', 'Blindaje Legal', 'Descargo sumario', 'Auditoría'];
export function Pricing() {
  const [selectedPlan, setSelectedPlan] = useState<'PRO' | 'Elite'>('Elite');
  return <div id="pricing" className="bg-slate-50 py-8 md:py-16" data-id="element-155">
      <SectionWrapper className="!py-0 md:!py-20" data-id="element-156">
        <div className="text-center mb-4 md:mb-10" data-id="element-157">
          <h2 className="text-[22px] md:text-3xl font-extrabold text-[#0a1f44] mb-1 md:mb-3 tracking-tight" data-id="element-158">
            Elegí tu Megapack
          </h2>
          <p className="text-slate-600 font-medium text-[13px] md:text-base" data-id="element-159">
            Ambas opciones incluyen los 6 bonos clínicos
          </p>
        </div>

        <div className="flex flex-col md:flex-row gap-3 md:gap-6 max-w-4xl mx-auto items-stretch" data-id="element-160">
          {/* PRO Card */}
          <motion.div whileHover={{
          scale: selectedPlan === 'PRO' ? 1 : 1.02
        }} onClick={() => setSelectedPlan('PRO')} className={`flex-1 rounded-2xl p-3.5 md:p-6 cursor-pointer border-2 transition-all relative flex flex-col ${selectedPlan === 'PRO' ? 'border-orange-500 bg-white shadow-lg ring-4 ring-orange-500/10' : 'border-slate-200 bg-white/60 hover:bg-white shadow-sm'}`} data-id="element-161">
            <div className="flex items-start justify-between md:block mb-2 md:mb-4" data-id="element-162">
              <div data-id="element-163">
                <h3 className="text-[16px] md:text-xl font-bold text-[#0a1f44] leading-tight" data-id="element-164">
                  Megapack Infantojuvenil PRO
                </h3>
                <p className="text-[12px] md:text-sm text-slate-500 mt-0.5 md:mt-1 font-medium" data-id="element-165">
                  6 Tomos + 6 Bonos
                </p>
              </div>
              <div className="text-right md:text-left md:mt-4 shrink-0" data-id="element-166">
                <div className="text-[12px] md:text-sm text-slate-400 line-through decoration-red-500/50 decoration-2 font-semibold leading-none" data-id="element-167">
                  $59.990
                </div>
                <div className="text-[22px] md:text-3xl font-black text-[#0a1f44] tracking-tight leading-tight" data-id="element-168">
                  $24.990
                </div>
              </div>
            </div>

            <div className="flex flex-wrap gap-x-3 gap-y-1.5 md:flex-col md:gap-y-3 md:space-y-0 mb-3 md:mb-6 flex-grow" data-id="element-169">
              {proFeatures.map(f => <div key={f} className="flex items-center gap-1.5 text-[12px] md:text-sm text-slate-700 font-medium" data-id="element-170">
                  <Check className="w-3.5 h-3.5 md:w-4 md:h-4 text-emerald-500 shrink-0" data-id="element-171" />{' '}
                  {f}
                </div>)}
            </div>

            <div className={`w-full py-2 md:py-3 rounded-xl text-center font-bold text-[12px] md:text-sm transition-colors ${selectedPlan === 'PRO' ? 'bg-orange-100 text-orange-700 ring-1 ring-orange-200' : 'bg-slate-100 text-slate-500'}`} data-id="element-172">
              {selectedPlan === 'PRO' ? 'Seleccionado' : 'Seleccionar PRO'}
            </div>
          </motion.div>

          {/* Elite Card */}
          <motion.div whileHover={{
          scale: selectedPlan === 'Elite' ? 1 : 1.02
        }} onClick={() => setSelectedPlan('Elite')} className={`flex-1 rounded-2xl p-3.5 md:p-6 cursor-pointer border-2 transition-all relative flex flex-col ${selectedPlan === 'Elite' ? 'border-[#0a1f44] bg-[#0a1f44] text-white shadow-xl ring-4 ring-[#0a1f44]/20 md:scale-105 z-10' : 'border-slate-200 bg-white hover:bg-slate-50 shadow-sm'}`} data-id="element-173">
            <div className="absolute -top-2.5 md:-top-4 left-1/2 -translate-x-1/2 bg-amber-400 text-amber-950 text-[9px] md:text-xs font-black px-2.5 md:px-3 py-0.5 md:py-1 rounded-full flex items-center gap-1 shadow-sm whitespace-nowrap tracking-wide" data-id="element-174">
              ⭐ MÁS ELEGIDA
            </div>

            <div className="flex items-start justify-between md:block mb-2 md:mb-4 mt-1 md:mt-2" data-id="element-175">
              <div data-id="element-176">
                <h3 className={`text-[16px] md:text-xl font-bold leading-tight ${selectedPlan === 'Elite' ? 'text-white' : 'text-[#0a1f44]'}`} data-id="element-177">
                  Megapack Infantojuvenil Elite
                </h3>
                <p className={`text-[11px] md:text-sm mt-0.5 md:mt-1 font-bold ${selectedPlan === 'Elite' ? 'text-amber-400' : 'text-blue-600'}`} data-id="element-178">
                  + Blindaje Legal Infantojuvenil Total
                </p>
              </div>
              <div className="text-right md:text-left md:mt-4 shrink-0" data-id="element-179">
                <div className={`text-[12px] md:text-sm line-through decoration-red-500/50 decoration-2 font-semibold leading-none ${selectedPlan === 'Elite' ? 'text-blue-300' : 'text-slate-400'}`} data-id="element-180">
                  $79.990
                </div>
                <div className={`text-[22px] md:text-3xl font-black tracking-tight leading-tight ${selectedPlan === 'Elite' ? 'text-white' : 'text-[#0a1f44]'}`} data-id="element-181">
                  $32.990
                </div>
              </div>
            </div>

            <div className="flex flex-wrap gap-x-3 gap-y-1.5 md:flex-col md:gap-y-3 md:space-y-0 mb-3 md:mb-6 flex-grow" data-id="element-182">
              {eliteFeatures.map((f, idx) => <div key={f} className={`flex items-center gap-1.5 text-[12px] md:text-sm ${idx === 1 ? 'font-bold' : 'font-medium'} ${selectedPlan === 'Elite' ? idx === 1 ? 'text-white' : 'text-blue-100' : idx === 1 ? 'text-slate-900' : 'text-slate-700'}`} data-id="element-183">
                  <Check className={`w-3.5 h-3.5 md:w-4 md:h-4 shrink-0 ${selectedPlan === 'Elite' ? 'text-amber-400' : 'text-emerald-500'}`} data-id="element-184" />{' '}
                  {f}
                </div>)}
            </div>

            <div className={`w-full py-2 md:py-3 rounded-xl text-center font-bold text-[12px] md:text-sm transition-colors ${selectedPlan === 'Elite' ? 'bg-amber-400 text-amber-950 shadow-inner' : 'bg-slate-100 text-slate-500'}`} data-id="element-185">
              {selectedPlan === 'Elite' ? 'Seleccionado' : 'Seleccionar Elite'}
            </div>
          </motion.div>
        </div>

        <SharedCTA selectedPlan={selectedPlan} data-id="element-186" />
      </SectionWrapper>
    </div>;
}